module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/zh-hans_okinawa-fc35bb7e479e180bb7c18b569f92f484.jpg";